module.exports = __webpack_public_path__ + "static/media/home-zhan.f0ea0768.png";